import React, { useState } from 'react'
import { Button, message, Upload, Form, Modal } from 'antd'
import axios from 'axios'
import { saveAs } from 'file-saver'
import { InboxOutlined } from '@ant-design/icons'

const { Dragger } = Upload

const App = () => {
  const [fileList, setFileList] = useState([])
  const [uploading, setUploading] = useState(false)
  const [blob, setBlob] = useState(null)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const handleUpload = () => {
    const formData = new FormData()
    fileList.forEach(file => {
      formData.append('docs', file.originFileObj)
    })
    setUploading(true)
    // axios
    // 使用axios发送POST请求进行多文件上传
    axios
      .post('/upload/mergeDoc', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        responseType: 'blob'
      })
      .then(res => {
        const blob = res.data
        setBlob(blob)
        // 创建一个URL，指向Blob对象
        setIsModalOpen(true)
        message.success('上传成功')
      })
      .catch(error => {
        message.error('上传失败')
        console.log(error)
      })
      .finally(() => {
        setUploading(false)
      })
  }
  // form回调方法
  const onFinish = () => {
    handleUpload()
  }
  const onFinishFailed = errorInfo => {
    console.log('Failed:', errorInfo)
  }
  // Modal回调方法
  const handleOk = () => {
    setIsModalOpen(false)
    saveAs(new Blob([blob], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' }), '合并Word.docx') // 设置下载文件名
  }
  const handleCancel = () => {
    setIsModalOpen(false)
  }
  const handleChange = ({ fileList: newFileList }) => setFileList(newFileList)
  // 上传按钮属性
  const props = {
    multiple: true,
    onRemove: file => {
      const index = fileList.indexOf(file)
      const newFileList = fileList.slice()
      newFileList.splice(index, 1)
      setFileList(newFileList)
    },
    beforeUpload: file => {
      const isDoc = file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      if (!isDoc) {
        message.error('只能上传docx格式!')
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 100
      if (!isLt2M) {
        message.error('上传文件最大100MB!')
        return false
      }
      return false
    },
    onChange: handleChange,
    fileList
  }
  return (
    <>
      <Dragger {...props} style={{ marginBottom: 30 }}>
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">点击或拖曳文件上传</p>
        <p className="ant-upload-hint">支持单文件与多文件上传，并且支持拖曳</p>
      </Dragger>
      <Form
        name="basic"
        labelCol={{
          span: 4
        }}
        wrapperCol={{
          span: 16
        }}
        style={{
          marginTop: '20px'
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Form.Item
          wrapperCol={{
            offset: 9,
            span: 4
          }}
        >
          <Button
            type="primary"
            htmlType="submit"
            loading={uploading}
            disabled={fileList.length < 2}
            style={{
              marginTop: 16
            }}
          >
            {uploading ? '上传中' : '开始上传'}
          </Button>
        </Form.Item>
      </Form>
      <Modal
        title="合并成功"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="下载"
        cancelText="取消"
      >
      </Modal>
    </>
  )
}
export default App
